import React, { useEffect, useState } from 'react';
import t from 'utils/translate';
import { useSelector } from 'react-redux';
import SimpleModal from 'modules/shared/components/simple-modal';
import Button from '@mui/material/Button';
import {
    saveCrossMuteListSettings,
    selectCrossMuteListDialogOpen,
    selectSettingsJson,
    toggleCallFwdDialogOpen,
    toggleCrossMuteListDialogOpen,
    updateJsonSetting,
} from '../stores/user-settings-slice-handler';
import { selectDataLoaded } from '../stores/company-settings-slice-handler';
import Preloader from '../../shared/components/preloader';
import ContactsSelector from '../../contacts/components/contacts-selector';

import TransferListArrows from '../../shared/components/transfer-list-arrows';
import {
    getContactsSelectorData,
    resetContactsSelectorData,
    sortMsisdnsList,
} from '../../contacts/stores/contacts-slice-handler';
import ContactsTransferList from '../../contacts/components/contacts-transfer-list';

function CrossMuteListDialog() {
    const companySettingsLoaded = useSelector(selectDataLoaded);

    if (!companySettingsLoaded) {
        return '';
    }

    /**
     * @type {UserSettingsJson}
     */
    const settingsJson = useSelector(selectSettingsJson);

    const [dataIsSaving, setDataIsSaving] = useState(false);
    const [crossMuteList, setCrossMuteList] = useState([]);

    useEffect(() => {
        setCrossMuteList(settingsJson.crossMuteList);
    }, [settingsJson.crossMuteList]);

    const dialogOpen = useSelector(selectCrossMuteListDialogOpen);

    /**
     * Close the dialog.
     */
    const closeDialog = () => {
        toggleCrossMuteListDialogOpen(false);
    };

    /**
     * Persist on server the cross mute list.
     */
    const saveData = () => {
        setDataIsSaving(true);

        updateJsonSetting(
            'crossMuteList',
            crossMuteList,
            t('settings_cross_mute_list_label'),
            t('settings_cross_mute_list_saved'),
        ).then(() => {
            setDataIsSaving(false);
            closeDialog();
        });
    };

    // just cut it short
    if (!dialogOpen) {
        return '';
    }

    return (
        <SimpleModal
            dialogTitle={t('settings_cross_mute_list_label')}
            closeCallback={() => closeDialog()}
            buttons={
                <div className="call-fwd-buttons-container">
                    <Button variant="contained" role="cancel" onClick={() => closeDialog()}>
                        {t('js_all_cancel')}
                    </Button>
                    <Button variant="contained" role="primary" onClick={() => saveData()}>
                        {t('js_all_save')}
                    </Button>
                </div>
            }
        >
            {dataIsSaving && <Preloader asOverlay />}
            <div className="cross-mute-list-dialog">
                <ContactsTransferList
                    recordsOnPage={50}
                    onTransfer={(data) => {
                        setCrossMuteList(data.msisdns);
                    }}
                    selectedContactsIds={{ msisdns: crossMuteList }}
                    onlyUsers={true}
                    listId={'cross-mute-list'}
                />
            </div>
        </SimpleModal>
    );
}
export default CrossMuteListDialog;
